import {Box, Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	margin: 0 auto;
	width: 100%;
	padding: 16px 16px 0;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px 32px 16px;
	}

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: 600px;
	}
`;

const StyledFooterBox = styled(Box)`
	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: 112px;
	}
`;

export {StyledContainer, StyledFooterBox};
